import { render, staticRenderFns } from "./sureDeleteAll.vue?vue&type=template&id=2377748a&"
import script from "./sureDeleteAll.vue?vue&type=script&lang=js&"
export * from "./sureDeleteAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports